import React, { FC, useContext } from "react";

import { css } from "@emotion/react";
import { getTextColor } from "@intelligems/ig-utils";

import { DiscountProgressBarContext } from "../../context";
import { BreakpointProps } from "../types";

export const CompletedBreakpoint2: FC<BreakpointProps> = () => {
  const { theme } = useContext(DiscountProgressBarContext);
  const circleClass = css`
    fill: ${theme.breakpoint.activeColor};
    stroke: ${theme.breakpoint.activeColor};
  `;

  const pathClass = css`
    fill: ${getTextColor(
      getComputedStyle(document.documentElement).getPropertyValue(
        theme.breakpoint.activeColorKey
      )
    )};
  `;

  return (
    <span className="ig-dp-completed-breakpoint filled">
      <svg width={28} height={28} fill="none">
        <circle cx={14} cy={14} r={13.5} css={circleClass} />
        <path
          css={pathClass}
          d="M11.129 16.825 7.804 13.5l-1.109 1.108 4.434 4.434 9.5-9.5-1.109-1.109-8.391 8.392Z"
        />
      </svg>
    </span>
  );
};
